import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { STCSchedulingConfigModel } from '../models/stc_scheduling_config_model';

export class AppointmentSchedulingServant {
  constructor(
    private loadStcScheduleConfigCommand: ICommand,
    private ngStcSchedulingConfigModel: STCSchedulingConfigModel,
    private appConfigModel: any
  ) {}

  public getSchedulingConfig() {
    const APPOINTMENT_SCHEDULE_FEATURE = 'model.member_features.ssccampus-appointment_scheduling';
    const shouldLoadConfig =
      _4.isUndefined(this.ngStcSchedulingConfigModel.read().v3_student_scheduler_flag) &&
      _4.get(this.appConfigModel, APPOINTMENT_SCHEDULE_FEATURE, false);
    return new Promise<void>((resolve, reject) => {
      if (shouldLoadConfig) {
        this.loadStcScheduleConfigCommand()
          .then(() => resolve())
          .catch((err) => reject(err));
      } else {
        resolve();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/servants/appointment_scheduling_servant.ts